
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/reporting",
      function () {
        return require("private-next-pages/sign/reporting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/reporting"])
      });
    }
  